import React from 'react';
import { Typography } from 'components/atoms';
import './index.scss';

interface Deadline {
  id: string;
  title: string;
  date: string;
  priority: 'high' | 'medium' | 'low';
  type: string;
}

interface UpcomingDeadlinesProps {
  deadlines: Deadline[];
}

export const UpcomingDeadlines: React.FC<UpcomingDeadlinesProps> = ({ deadlines }) => {
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high':
        return '#dc3545';
      case 'medium':
        return '#ffc107';
      case 'low':
        return '#28a745';
      default:
        return '#6c757d';
    }
  };

  const getPriorityIcon = (priority: string) => {
    switch (priority) {
      case 'high':
        return 'ri-error-warning-line';
      case 'medium':
        return 'ri-time-line';
      case 'low':
        return 'ri-check-line';
      default:
        return 'ri-information-line';
    }
  };

  return (
    <div className="upcoming-deadlines-card">
      <div className="card-header">
        <div className="header-content">
          <i className="ri-calendar-event-line header-icon"></i>
          <Typography type="heading5" text="Upcoming Deadlines" weight="bold" />
        </div>
      </div>
      
      <div className="deadlines-list">
        {deadlines.map((deadline) => (
          <div key={deadline.id} className="deadline-item">
            <div className="deadline-priority">
              <i 
                className={getPriorityIcon(deadline.priority)}
                style={{ color: getPriorityColor(deadline.priority) }}
              ></i>
            </div>
            <div className="deadline-content">
              <Typography type="base_regular" text={deadline.title} weight="bold" />
              <div className="deadline-meta">
                <Typography type="small_regular" text={deadline.date} color="gray" />
                <span 
                  className="priority-badge"
                  style={{ backgroundColor: getPriorityColor(deadline.priority) }}
                >
                  {deadline.priority}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}; 